/** Time frame types for dashboard date selection */
export enum TimeFrame {
  TRAILING = 'Trailing',
  WEEK = 'Week',
  MONTH = 'Month',
  QUARTER = 'Quarter',
  HALF = 'Half',
  YEAR = 'Year',
  YTD = 'YTD',
  CUSTOM_DATE = 'Custom Date',
}

/** Default trailing period in days */
export const DEFAULT_TRAILING_DAYS = 30 as const
